import { getDebounce } from "utils";
import { maskDate } from "../../../../utils";
import { submitApplication } from "../../../../utilities";
import setLoading from "components/loading";

const debounce = getDebounce()

const luhnCheck = (value) => {
  if (/^[^0-9-\s]+$/.test(value) || value.length < 13 || value.length > 19 ) {
    return false;
  }

  let nCheck = 0;
  let bEven = false;
  value = value.replace(/\D/g, "");

  for (let n = value.length - 1; n >= 0; n--) {
    const cDigit = value.charAt(n);
    let nDigit = parseInt(cDigit, 10);
    if (bEven) {
      if ((nDigit *= 2) > 9) nDigit -= 9;
    }
    nCheck += nDigit;
    bEven = !bEven;
  }

  return (nCheck % 10) === 0 ? true : false;
};

const cardValidations = (field, updatedCardInfo) => {
  let errors = {};

  const { fullName, cardNumber, cardCode,  expiration, zip } = updatedCardInfo;

  const validName = fullName.length>0 && !!fullName.match(/^[a-zA-Z\s]*$/)
  if ((field == 'name' || field == 'all') && !validName) {
    errors = { ...errors, fullNameError: 'Name is required' };
  }

  const validCard = luhnCheck(cardNumber)
  if ((field == 'cardNumber' || field == 'all') && !validCard) {
    errors = { ...errors, cardNumberError: 'Card number is required' };
  }

  const expirationDate = !!expiration.match(/^\d{2}\/\d{2}$/)
  if ((field == 'expiration' || field == 'all') && !expirationDate) {
    errors = { ...errors, expirationError: 'Expiry date is required' };
  }

  const validNum = !!cardCode.match(/^\d{3,4}$/)
  if ((field == 'cvv' || field == 'all') && !validNum) {
    errors = { ...errors, cardCodeError: 'CVV is required' };
  }

  const ValidZip = !!zip.match(/^\d{5}$/)
  if ((field == 'zip' || field == 'all') && !ValidZip) {
    errors = { ...errors, zipError: 'Five-digit ZIP code of your billing address is required' };
  }


  if (Object.keys(errors).length) {
    const withErrors = { ...updatedCardInfo, ...errors, hasError: true }
    return withErrors;
  }
  else return { ...updatedCardInfo, hasError: false }
}

const validator = (field, updatedCardInfo, stateManager) => {
    const result = cardValidations(field, updatedCardInfo)
    stateManager.setCardDetails(result)
}

const validate = (field, updatedCardInfo, stateManager) => {
  debounce(() => validator(field, updatedCardInfo, stateManager), 3000);
}



export default {
  'ModalBody.Container.AgreeSection.Field.Name': ({ cardDetails, value }, stateManager) => {
    stateManager.setLeaseholderName(value);
  },
  'ModalBody.Button': ({ paidFee, cardDetails, property }, stateManager) => {
    if (paidFee > 0) {
      const result = cardValidations('all', cardDetails)
      const hasError = result.hasError
      stateManager.setCardDetails(result)

      if(hasError) return

      stateManager.setTermsAccepted(false)
      stateManager.setPaymentAuthorization(true)
      stateManager.setPaidFee(paidFee)
    } else {
      setLoading(true)
      submitApplication(stateManager, null, property).then(() => {
        stateManager.setTermsAccepted(false)
        stateManager.setPaymentAuthorization(false)
        stateManager.setTermsModal(false);
      })
    }
  },
  'ModalBody.Container.InputFields.Name': ({ cardDetails, value }, stateManager) => {
    const updatedCardInfo = { ...cardDetails, focusedField: 'fullName', fullName: value, fullNameError: '' }
    stateManager.setCardDetails(updatedCardInfo)

    validate('name', updatedCardInfo, stateManager)
  },
  'ModalBody.Container.InputFields.CardNumber': ({ cardDetails, value }, stateManager) => {
    const updatedCardInfo = { ...cardDetails, focusedField: 'cardNumber', cardNumber: value, cardNumberError: '' }
    stateManager.setCardDetails(updatedCardInfo)

    validate('cardNumber', updatedCardInfo, stateManager)
  },
  'ModalBody.Container.InputFields.CVV': ({ cardDetails, value }, stateManager) => {
    if(value.length > 4) return

    const updatedCardInfo = { ...cardDetails, focusedField: 'cvv', cardCode: value, cardCodeError: '' }
    stateManager.setCardDetails(updatedCardInfo)

    validate('cvv', updatedCardInfo, stateManager)
  },
  'ModalBody.Container.InputFields.Expiration': ({ cardDetails, value }, stateManager) => {

    const date = maskDate(value)
    const updatedCardInfo = { ...cardDetails, focusedField: 'expiration', expiration: date, expirationError: '' }
    stateManager.setCardDetails(updatedCardInfo)

    validate('expiration', updatedCardInfo, stateManager)
  },
  'ModalBody.Container.InputFields.ZIP': ({ cardDetails, value }, stateManager) => {
    if(value.length > 5) return

    const updatedCardInfo = { ...cardDetails, focusedField: 'zip', zip: value, zipError: '' }
    stateManager.setCardDetails(updatedCardInfo)

    validate('zip', updatedCardInfo, stateManager)
  },
  'ModalBody.Container.InputFields.IsAdminFeePaid': ({ cardDetails, checked }, stateManager) => {
    stateManager.setCardDetails({ ...cardDetails, IsAdminFeePaid: !checked })
  },
}
